export default __webpack_public_path__ + "static/media/bg-video.89552ba1.mp4";